"use strict";
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSchema = validateSchema;
var Either_1 = require("fp-ts/lib/Either");
/**
 * Validates the event according to the schema validator generated by {@link convertSchemaToIoTs}.
 * @throws Error when the event does not comply with the schema.
 * @param validator The io-ts validator for the event.
 * @param payload The payload to validate.
 */
function validateSchema(sourceName, validator, payload) {
    // Run io-ts validation to the event
    var result = validator.decode(payload);
    Either_1.either.mapLeft(result, function (validationErrors) {
        var humanFriendlyErrors = validationErrors
            .map(function (err) { var _a; return "[".concat(getFullPathKey(err.context), "]: ").concat((_a = err.message) !== null && _a !== void 0 ? _a : readableContext(err.context)); })
            .filter(function (errMsg, idx, listOfErrMsgs) { return listOfErrMsgs.indexOf(errMsg, idx + 1) === -1; });
        throw new Error("Failed to validate payload coming from \"".concat(sourceName, "\":\n\t- ").concat(humanFriendlyErrors.join('\n\t- ')));
    });
}
/**
 * Picks the relevant fields of the validation error's context
 * @param context The {@link Context} coming from the validation error
 */
function readableContext(context) {
    // The information provided, the last context is good enough.
    // Otherwise, repeating the values for every nested key is too noisy.
    var last = context[context.length - 1];
    return JSON.stringify({
        expected: last.type.name,
        // Explicitly printing `undefined` to make it more obvious in the message
        actual: typeof last.actual,
        value: last.actual === undefined ? 'undefined' : last.actual,
    });
}
/**
 * Prints the full path to the key that raised the validation error.
 * @param context The {@link Context} coming from the validation error
 */
function getFullPathKey(context) {
    return (context
        // Remove the context provided by InterfaceType and PartialType because their keys are simply numeric indices
        .filter(function (ctx) { return !['InterfaceType', 'PartialType'].includes(ctx.type._tag); })
        .map(function (_a) {
        var key = _a.key;
        return key;
    })
        .filter(Boolean)
        .join('.'));
}
